import { useCallback } from 'react';
import { supabase } from '../providers/supabase/supabase';

export type IpaCsvRow = {
    Crop?: string;
    crop?: string;
    Class?: string;
    class?: string;
    IPA?: string | number;
    ipa?: string | number;
    State?: string;
    state?: string;
    AIP?: string;
    aip?: string;
};

function normalizeRow(raw: IpaCsvRow) {
    const crop = (raw.Crop ?? raw.crop ?? '').toString().trim();
    const cls = (raw.Class ?? raw.class ?? '').toString().trim();
    const state = (raw.State ?? raw.state ?? '').toString().trim();
    const aip = (raw.AIP ?? raw.aip ?? '').toString().trim();

    const ipaRaw = raw.IPA ?? raw.ipa;
    const ipaParsed =
        ipaRaw != null && ipaRaw !== ''
            ? parseInt(String(ipaRaw).replace(/[$,\s]/g, ''), 10)
            : NaN;

    return {
        crop,
        class: cls,
        ipa: isNaN(ipaParsed) ? null : ipaParsed,
        state,
        aip,
    };
}

export function useIpaImport() {
    const processBatch = useCallback(async (batch: IpaCsvRow[]) => {
        const rows = batch
            .map(normalizeRow)
            .filter(
                r => r.crop && r.class && r.ipa != null && r.state && r.aip
            );

        if (rows.length === 0) return;

        const { error } = await supabase.from('ipa_manager').insert(rows);

        if (error) {
            console.error('IPA import batch error:', error);
            throw error;
        }
    }, []);

    return { processBatch };
}
